(function () {
  var initialized = new WeakSet();
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-cs-instagram-path]');
      if (!link || !root.contains(link)) return;
      var detail = {
        path: link.getAttribute('data-cs-instagram-path') || '',
        link_url: link.href || '',
        link_text: (link.textContent || '').replace(/\s+/g, ' ').trim(),
        section: link.getAttribute('data-cs-instagram-position') || '',
        position: link.getAttribute('data-cs-instagram-position') || '',
        content_type: link.getAttribute('data-cs-instagram-content') || ''
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event: 'cs_instagram_path_click'}, detail));
      window.dispatchEvent(new CustomEvent('cs:analytics', {detail: Object.assign({eventName: 'cs_instagram_path_click'}, detail)}));
    });
    var video = root.querySelector('[data-instagram-video-id]');
    var poster = root.querySelector('.cs-instagram-video__poster');
    if (!video || !poster) return;
    poster.addEventListener('click', function () {
      var id = video.getAttribute('data-instagram-video-id');
      if (!/^[A-Za-z0-9_-]{11}$/.test(id || '') || video.getAttribute('data-playing') === 'true') return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.title = poster.getAttribute('aria-label') || 'MicroBio+';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      video.setAttribute('data-playing', 'true');
      video.replaceChildren(iframe);
    });
  }
  function ready() { document.querySelectorAll('[data-cs-instagram]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true}); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
